const INVALID_PASSWORD_MESSAGE = "NG: Invalid password";
const SUCCESS_RESPONSE_PATTERN = /^OK:\s*user_id\s*=\s*([1-9]\d*)\s*$/;

// ユーザー作成APIの応答は成功形式だけを受け付け、NG・空・不正な応答での受験開始を防ぐ。
export const parseTopInfoResponse = (response) => {
  const message = typeof response === "string" ? response : response?.message;
  const normalizedMessage = typeof message === "string" ? message.trim() : "";
  const responseMessage = normalizedMessage.replace(/^response:/, "");

  if (responseMessage === INVALID_PASSWORD_MESSAGE) {
    return { isSuccess: false, reason: "invalid_password" };
  }

  const userIdMatch = responseMessage.match(SUCCESS_RESPONSE_PATTERN);
  if (userIdMatch) {
    return { isSuccess: true, userId: Number(userIdMatch[1]) };
  }

  return { isSuccess: false, reason: "invalid_response" };
};
